import { inject, Injectable } from '@angular/core';
import { SegmentModalStore } from './segment-modal.store';
import { EMPTY, finalize } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { SegmentForm } from './segment-modal.model';
import { SectorService } from '../../core/sector/sector.service';

@Injectable()
export class SegmentModalFacade {
  readonly #segmentModalStore = inject(SegmentModalStore);
  readonly #sectorService = inject(SectorService);

  buildAudience(segmentForm: FormGroup<SegmentForm>) {
    const { platform, comment } = segmentForm.getRawValue();

    if (platform == null) {
      return EMPTY;
    }

    this.#segmentModalStore.updateIsLoading(true);

    return this.#sectorService
      .createSegment({ platform, comment })
      .pipe(finalize(() => this.#segmentModalStore.updateIsLoading(false)));
  }
}
